export default __webpack_public_path__ + "static/blob4-d9abb542e039de65b0dc0b237e99e805.svg";